export const openModal = async ({ commit }, data) => {
  commit('setModal', data);
}
export const closeModal = async ({ commit }) => {
  commit('setModal');
}